const maintenanceStatFields = [
  'faulty',
  'audio_problems',
  'fm_reception_problems',
  'cell_reception',
  'radio_zero',
  'battery',
  'inactive',
  'total_sensors',
  'sensors_replace',
  'to_check',
];

const hasMaintenanceStats = (value) => (
  value
  && typeof value === 'object'
  && !Array.isArray(value)
  && maintenanceStatFields.some((field) => (
    Object.prototype.hasOwnProperty.call(value, field)
  ))
);

export const normalizeMaintenanceDashboardData = (payload, projectId) => {
  const responseData = payload?.data ?? payload ?? {};
  const maintenanceStatsSource = responseData?.maintenanceStats
    ?? (Array.isArray(responseData) || hasMaintenanceStats(responseData)
      ? responseData
      : []);

  const maintenanceStats = Array.isArray(maintenanceStatsSource)
    ? maintenanceStatsSource
    : maintenanceStatsSource
      ? [maintenanceStatsSource]
      : [];

  const maintenanceData = maintenanceStats.find(
    (item) => String(item?.project_id) === String(projectId)
  ) || maintenanceStats[0] || {};

  const maintenanceSensors = responseData.maintenanceSensors
    && typeof responseData.maintenanceSensors === 'object'
    ? responseData.maintenanceSensors
    : {};

  return { maintenanceData, maintenanceSensors };
};

export const buildProblemBreakdown = (maintenanceSensors, problemKey) => (
  Object.entries(maintenanceSensors || {}).map(([sensorType, sensorData], index) => ({
    device_type: index,
    Meaning: sensorType,
    num_active_sensors: Number(sensorData?.[problemKey]?.false) || 0,
    num_inactive_sensors: Number(sensorData?.[problemKey]?.true) || 0,
  }))
);

export const normalizeMaintenanceReportSensors = (payload) => {
  const responseData = payload?.data || payload || {};
  const sensors = Array.isArray(responseData)
    ? responseData
    : responseData.sensors || responseData.items || responseData.rows || [];

  return Array.isArray(sensors) ? sensors : [];
};
